export function dataUrlToFile(dataUrl: string, fileName: string): File {
  const [header = '', base64 = ''] = dataUrl.split(',')
  const mimeType = header.match(/data:(.*?);/)?.[1] ?? ''
  const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0))
  return new File([bytes], fileName, { type: mimeType })
}
